import type { PeopleProfileState } from './types';

export const selectSortingMeta = (state: {
  peopleProfile: PeopleProfileState,
}) => state.peopleProfile.columnOrder;
